import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';

const FIXED_BUTTON_LABEL = 'Agendar una reunión';

const EMPTY_FORM = {
  title: '', subtitle: '', buttonLabel: FIXED_BUTTON_LABEL, href: '',
};

function CtaBlockModal({
  open, onClose, onSubmit, initialValues,
}) {
  const [form, setForm] = useState(EMPTY_FORM);
  const isEditing = Boolean(initialValues);

  useEffect(() => {
    if (open) setForm(initialValues || EMPTY_FORM);
  }, [open, initialValues]);

  const handleChange = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const isValid = form.title.trim() && form.href.trim();

  const handleSubmit = () => {
    if (!isValid) return;
    onSubmit({ ...form, buttonLabel: FIXED_BUTTON_LABEL });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEditing ? 'Editar bloque CTA' : 'Insertar bloque CTA'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Título"
          fullWidth
          margin="normal"
          value={form.title}
          onChange={handleChange('title')}
        />
        <TextField
          label="Descripción"
          fullWidth
          margin="normal"
          multiline
          value={form.subtitle}
          onChange={handleChange('subtitle')}
        />
        <TextField
          label="URL del botón"
          fullWidth
          margin="normal"
          placeholder="https://..."
          value={form.href}
          onChange={handleChange('href')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={!isValid}>
          {isEditing ? 'Guardar' : 'Insertar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CtaBlockModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    buttonLabel: PropTypes.string,
    href: PropTypes.string,
  }),
};

CtaBlockModal.defaultProps = {
  initialValues: null,
};

export default CtaBlockModal;
